import axiosInstance from '../utils/setupAxios';

// Admin API for SongSnap app versioning (OC-725), served by appixi-core under
// /songs/admin/client-versions (song.admin):
//   GET  /                       -> { features: [...], platforms: [...] }
//   GET  /seen                   ?days -> { days, items: [{ platform, app_version, requests, devices, last_seen_at, sources }] }
//   POST /features               { key, name, description?, enabled?, min_version_ios?, min_version_android? }
//   POST /features/{id}          { name?, description?, enabled?, min_version_ios?, min_version_android? }
//   POST /platforms/{platform}   { min_supported_version?, recommended_version? }
const BASE = '/songs/admin/client-versions';

export function fetchClientVersionRules() {
  return axiosInstance.get(BASE);
}

export function fetchSeenVersions(days = 7) {
  return axiosInstance.get(`${BASE}/seen`, { params: { days } });
}

export function createClientFeature(data) {
  return axiosInstance.post(`${BASE}/features`, data);
}

export function updateClientFeature(id, data) {
  return axiosInstance.post(`${BASE}/features/${id}`, data);
}

export function updatePlatformVersions(platform, data) {
  return axiosInstance.post(`${BASE}/platforms/${platform}`, data);
}

// Laravel validation errors come back as { message, errors: { field: [msg] } }.
export function apiErrorMessage(error) {
  const body = error?.response?.data;
  if (body?.errors) {
    return Object.values(body.errors).flat().join(' ');
  }
  if (body?.message === 'forbidden') {
    return 'This account is not allowed to change app version rules.';
  }
  return body?.message || error?.message || 'Request failed';
}
